import React, { ComponentProps, useCallback } from "react";

import Menu from "antd/es/menu";

import Interactive from "@app/component/map/FeaturedMap/essentials/controls/Interactive";
import OverlayView from "@app/component/map/FeaturedMap/essentials/OverlayView";
import useMap from "@app/component/map/FeaturedMap/utils/useMap";

import styles from "./ContextMenu.module.scss";

interface Props {
  children: ComponentProps<typeof Menu>["children"];
  onHide: () => void;
  showAt?: google.maps.LatLng | google.maps.LatLngLiteral;
}

const MapContextMenu: React.FC<Props> = ({ children, onHide, showAt }) => {
  const { map } = useMap();
  const handleHide = useCallback(() => onHide(), [onHide]);

  return map && showAt ? (
    <OverlayView map={map} onClickOutside={handleHide} position={showAt}>
      <Interactive>
        <Menu className={styles.menu} mode="vertical" onClick={handleHide} selectable={false}>
          {children}
        </Menu>
      </Interactive>
    </OverlayView>
  ) : null;
};

export default MapContextMenu;
